import type { TaskStatusUnionType } from '@api';
import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type TaskStatusBadgePropsType = {
  status: TaskStatusUnionType;
};

const STATUS_COLOR: Record<TaskStatusUnionType, string> = {
  OPEN: 'blue',
  CLOSED: 'gray',
};

export const TaskStatusBadge: React.FC<TaskStatusBadgePropsType> = ({
  status,
}) => {
  const { t } = useTranslation('tasks');

  return (
    <Badge variant="light" color={STATUS_COLOR[status]} size="sm" radius="sm">
      {t(`STATUS.${status}`)}
    </Badge>
  );
};
